/**
 * Maps OncoEMR task API rows to left-panel list card props.
 * @module mapTaskListItemToPanelItem
 */

import { OncoemrTaskListItem } from "../../../../../data-model/oncoemrTasksModel";
import { formatDate } from "../../../../../utils/formatDate";
import {
  ONCOEMR_MESSAGE_SENDER_UNKNOWN,
  resolveMessageSenderDisplayName,
} from "../../../../../utils/oncoemrTaskHelpers";
import type { TaskListPanelItem } from "../components/tasksListPanel";

const LAST_ACTIVITY_FORMAT = "M/D/YY, h:mm A";

/**
 * Builds subtitle text from the latest message sender (`sender_name`, then `sender_user_id`, else "—").
 *
 * @param task - Task list item from the API.
 * @returns Subtitle string for {@link TaskListPanelItem}.
 */
const buildTaskSubtitle = (task: OncoemrTaskListItem): string => {
  if (!task.last_message) {
    return ONCOEMR_MESSAGE_SENDER_UNKNOWN;
  }

  return resolveMessageSenderDisplayName(task.last_message);
};

/**
 * Converts an API task row into props for {@link TasksListPanel}.
 *
 * @param task - Task list item from an OncoEMR tasks list endpoint.
 * @returns Panel row used by the left task navbar.
 */
export const mapTaskListItemToPanelItem = (
  task: OncoemrTaskListItem,
): TaskListPanelItem => ({
  id: task.id,
  title: task.title,
  subtitle: buildTaskSubtitle(task),
  metaLabel: formatDate(task.last_activity_at, LAST_ACTIVITY_FORMAT),
  isInProgress: task.status === "in_progress",
  isUpdated: task.is_updated,
});
